import { createSelector } from "reselect";
import { RootState } from "RootReducer";

export const getHasHazmat = createSelector(
  (state: RootState) => state.inbound.productDetailsCache,
  (productDetailsCache) =>
    Object.values(productDetailsCache).some(({ hazmatInformation }) => hazmatInformation !== undefined)
);
